import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as me from '../../me'
import type { Feature } from '../feature'

/** Loads File Finder metadata for the active zone. */
export const loadFinderFilesOnRequest = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.loadFinderFiles.request.observe().pipe(
      rxjsUtils.latestFrom(action => ({
        action: rxjs.of(action),
        context: meFeature.contexts.selectors.zoneContext.asObservable,
      })),
      rxjs.mergeMap(({ action, context }) =>
        context
          ? feature.api.listFinderFiles(context).pipe(
              rxjs.map(response =>
                feature.actions.loadFinderFiles.success.from(action).create({
                  request: action.data,
                  response,
                }),
              ),
              rxjs.catchError((error: unknown) =>
                rxjs.of(
                  feature.actions.loadFinderFiles.error.from(action).create({
                    error:
                      error instanceof Error ? error : new Error(String(error)),
                    request: action.data,
                  }),
                ),
              ),
            )
          : rxjs.of(
              feature.actions.loadFinderFiles.cancellation.from(action).create({
                reason: 'Not in a valid zone context',
                request: action.data,
              }),
            ),
      ),
    ),
)
